// Get locale into js
locale = $('html').attr('lang');
//console.log(locale);

$(document).ready(function () {

    // Check if on the pricing page
    if ($('#pricing').length > 0) {
        // if matches string 'us' need USD
        if (locale === 'us') {
            $('.us-price').removeClass('d-none');
            $('.uk-price').addClass('d-none');

        }
    }
});



